module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/modules/$.add-to-unscopables.js
// module id = 472
// module chunks = 0